import React, { useEffect, useState } from "react";
import styles from "./Hero.module.scss";
import homeStyles from "../../../../styles/Home.module.scss";
import Image from "next/image";
import FallbackGradient from "../../../Common/FallbackGradient/FallbackGradient";

function Hero() {
  const stats = [
    {
      icon: "/agent-icons/cart.svg",
      label: "Order Processing",
      value: "1M+/month",
      description: "Orders processed monthly",
      color: "#3b82f6", // Blue
    },
    {
      icon: "/agent-icons/users.svg",
      label: "Self-managed Commerce",
      value: "1K+",
      description: "Commerce controls",
      color: "#10b981", // Green
    },
    {
      icon: "/agent-icons/bar.svg",
      label: "Real-time Analytics",
      value: "<100ms",
      description: "Data processing latency",
      color: "#f59e0b", // Orange
    },
    {
      icon: "/agent-icons/target.svg",
      label: "Security Compliance",
      value: "99.9%",
      description: "Uptime & data protection",
      color: "#ef4444", // Red
    },
  ];
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.3 }
    );
    const el = document.querySelector(`.${styles.heroSection}`);
    if (el) observer.observe(el);
    return () => observer.disconnect();
  }, []);
  
  return (
    <section className={styles.heroSection}>
    <div className={styles.heroShadowWrapper}>
      <FallbackGradient />
    </div>
  
    <div className={styles.heroGrid}>
      {/* Left Column - Text */}
      <div
        className={`${styles.leftColumn} ${isVisible ? styles.animateLeft : styles.hidden}`}
      >
        <div className={styles.heroContent}>
          <div className={`${styles.heroBadge} tag`}>Enterprise Commerce Platform</div>
  
          <h1 className="heading">
            Comprehensive
            <br />
            <span className={homeStyles["span-gradient"]}>B2C Marketplace & D2C Brand</span>
            <br />
            Functionality Suite
          </h1>
  
          <p className={`${styles.heroDescription} subHeading`}>
            Transform Your B2B eCommerce to Keep up with Consumer expectations.
            Plug and Play with our No-code B2C stack to rapidly design, launch,
            and optimize your business to drive customer engagement, conversion,
            revenue, and loyalty.
          </p>
        </div>
      </div>
  
      {/* Right Column - Image */}
      <div
        className={`${styles.rightColumn} ${isVisible ? styles.animateRight : styles.hidden}`}
      >
        <div className={styles.imageWrapper}>
          <img
            src="/b2b/b2d-hero.webp"
            alt="Marketplace Illustration"
            className={styles.image}
          />
        </div>
      </div>
    </div>
  
    {/* Stats Grid */}
    <div className={styles.statsGrid}>
      {stats.map((stat, index) => (
        <div key={index} className={styles.statCard}>
          <div className={styles.statIconWrapper} style={{ backgroundColor: stat.color }}>
            <Image src={stat.icon} alt={stat.label} width={28} height={28} className={styles.statIcon} />
          </div>
          <div className={styles.statValue}>{stat.value}</div>
          <div className={styles.statLabel}>{stat.label}</div>
          <div className={styles.statDescription}>{stat.description}</div>
        </div>
      ))}
    </div>
  </section>
  
  );
}

export default Hero;
